import Swiper from 'swiper';
import 'jquery';
import onDocumentReady from '../util/onDocumentReady';

onDocumentReady(() => new Swiper('.another-articles .swiper-container', {
    speed: 600,
    spaceBetween: 20,
    slidesPerView: 4,
    autoHeight: true,
    pagination: {
        el: '.another-articles-control__pagination',
        type: 'fraction',
    },
    navigation: {
        nextEl: '.another-articles-control__button--next',
        prevEl: '.another-articles-control__button--prev',
    },

    breakpoints: {
        767: {
            slidesPerView: 1,
        },
        1439: {
            slidesPerView: 3,
        },
    },
}));
